type FrequencyUnit = 'minute' | 'hour' | 'day' | 'week' | 'month';

const UNIT_LABELS: Record<FrequencyUnit, string> = {
  minute: '/ min',
  hour: '/ hour',
  day: '/ day',
  week: '/ week',
  month: '/ month',
};

const formatNumber = (value: number): string => {
  if (value >= 1000) {
    const scaled = value / 1000;
    const fixed = Number.isInteger(scaled) ? scaled.toFixed(0) : scaled.toFixed(1);
    return `${fixed.replace(/\.0$/, '')}k`;
  }
  const rounded = Number.isInteger(value) ? value.toFixed(0) : value.toFixed(1);
  return rounded.replace(/\.0$/, '');
};

const formatPerUnit = (perDay: number, unit: Exclude<FrequencyUnit, 'minute'>): string => {
  if (unit === 'hour') return `${formatNumber(perDay / 24)} ${UNIT_LABELS.hour}`;
  if (unit === 'day') return `${formatNumber(perDay)} ${UNIT_LABELS.day}`;
  if (unit === 'week') return `${formatNumber(perDay * 7)} ${UNIT_LABELS.week}`;
  return `${formatNumber(perDay * 30)} ${UNIT_LABELS.month}`;
};

export const formatFrequency = (
  perDay: number,
  preferredUnit?: Exclude<FrequencyUnit, 'minute'>,
): string => {
  if (preferredUnit) return formatPerUnit(perDay, preferredUnit);
  const perMinute = perDay / 1440;
  const perHour = perDay / 24;
  const perWeek = perDay * 7;
  if (perMinute >= 1) return `${formatNumber(perMinute)} ${UNIT_LABELS.minute}`;
  if (perHour >= 1) return `${formatNumber(perHour)} ${UNIT_LABELS.hour}`;
  if (perDay >= 1) return `${formatNumber(perDay)} ${UNIT_LABELS.day}`;
  if (perWeek >= 1) return `${formatNumber(perWeek)} ${UNIT_LABELS.week}`;
  return `${formatNumber(perDay * 30)} ${UNIT_LABELS.month}`;
};
